import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import logoPilari from '../assets/images/pilari_dark.png';
import pilariQRLogo from '../assets/icons/pilari_logo_outline.png';
import { Smartphone, AlertCircle } from 'lucide-react';

const installLink = 'https://pilari.app/install';

const InstallCard = () => {
    return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-6">
            {/* Logo Pilari */}
            <img src={logoPilari} alt="Pilari Logo" className="w-72 h-auto mb-6 pb-5" />

            {/* QR Code dengan logo tengah */}
            <div className="relative w-[320px] h-[320px]">
                <QRCodeCanvas value={installLink} size={320} />
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <img src={pilariQRLogo} alt="Logo Tengah" className="w-24 h-24" />
                </div>
            </div>

            {/* Link */}
            <p className="text-sm text-gray-500 mt-2 pt-5">{installLink}</p>

            {/* Info hanya untuk Android */}
            <div className="mt-2 flex items-center text-xs text-red-500">
                <AlertCircle className="w-4 h-4 mr-1" />
                Aplikasi saat ini hanya tersedia untuk perangkat Android
            </div>

            {/* Kartu Cara Instalasi */}
            <div className="mt-6 bg-white rounded-2xl shadow px-6 py-5 w-full max-w-md border border-gray-200 text-sm text-gray-700 leading-relaxed text-center">
                <div className="flex flex-col items-center text-green-600 font-semibold text-sm mb-3">
                    <Smartphone className="w-4 h-4 mb-1" />
                    <span>Cara Instalasi</span>
                </div>

                <ol className="list-none space-y-1">
                    <li>1. Tekan tombol download di atas.</li>
                    <li>2. Buka file APK yang telah diunduh.</li>
                    <li>3. Aktifkan opsi “Izinkan dari sumber ini” jika diminta.</li>
                    <li>4. Lanjutkan proses instalasi seperti biasa.</li>
                    <li>5. Buka aplikasi Pilari dan mulai gunakan!</li>
                </ol>
            </div>
        </div>
    );
};

export default InstallCard;
